import React from 'react';
import styled from 'styled-components';
import DashboardAddContent from '../DashboardAddContent';
import EmptyDashboardVector from '../../../components/EmptyDashboardVector';
import { SecondaryButton } from '../../../../../components/Button';
import { SvgIcon } from '../../../../../components/Icon';

interface IProps {
  showAddContent: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 32px;
  padding-top: 84px;
`;

const DashboardNoContent = ({ showAddContent }: IProps) => {
  return (
    <Container>
      <EmptyDashboardVector />
      {showAddContent && (
        <DashboardAddContent
          label={
            <SecondaryButton isOutlined={true}>
              <SvgIcon
                name="plus"
                width={16}
                height={16}
                customFill="currentColor"
              />
              Add Content
            </SecondaryButton>
          }
        />
      )}
    </Container>
  );
};

export default DashboardNoContent;
